import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar'; // Import MatSnackBar
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

//  @author Kameshwar
//  @date 09-10-2024

@Component({
    selector: 'app-export-dialog',
    templateUrl: './export-dialog.component.html',
    styleUrls: ['./export-dialog.component.scss'],
    standalone: false
})
export class ExportDialogComponent implements OnInit {
  datasets: any[]; // Array of all datasets
  objectGroupNames: any[]; // Array of object groups
  selectedDatasets: any[] = []; // Selected datasets
  selectedOptions: any[] = []; // Selected object groups
  filteredDatasets: any[] = []; // Datasets for the selected object groups
  backgroundColorButton = "";

  // Map to store object group ID and name
  objectGroupMap: Map<number, string> = new Map<number, string>();
  backgroundColorScreen: any;
  // localStorageSettings: any;
  buttonColor: any;

  constructor(
    public dialogRef: MatDialogRef<ExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonservice: CommonService,
    private spinner: NgxUiLoaderService,
    private localStorageSettings: LocalStorageSettingsService,
    private snackBar: MatSnackBar // Inject MatSnackBar
  ) {
    this.datasets = data.datasets;
    this.objectGroupNames = data.ObjectGroups;

    // Initialize the object group map
    this.objectGroupNames.forEach(group => {
      this.objectGroupMap.set(group.objectGroupId, group.objectGroupName);
    });
  }
  ngOnInit(): void {
    this.backgroundColorScreen =
    this.localStorageSettings.getSettings("ColorD");
  this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
  console.log("Retrieved ColorA:", this.buttonColor);

  }

  // Called when the selected object group changes
  onObjectGroupChange(objectGroupIds: any[]): void {
    this.selectedOptions = objectGroupIds;
    
    // Filter datasets for all selected object groups
    this.filteredDatasets = this.datasets.filter(dataset => 
      objectGroupIds.includes(Number(dataset.objectGroup))
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  async confirm(): Promise<void> {
    // Validate selected options and datasets
    if (this.selectedOptions.length === 0) {
      this.snackBar.open('Please select at least one object group.', 'Close', {
        duration: 3000,
        horizontalPosition: 'center'
      });
      return;
    }

    if (this.selectedDatasets.length === 0) {
      this.snackBar.open('Please select at least one dataset to export.', 'Close', {
        duration: 3000,
        horizontalPosition: 'center'
      });
      return;
    }

    const exportData: { [key: number]: string } = {};

    for (const objectGroupId of this.selectedOptions) {
      const datasetIds = this.datasets
        .filter(dataset =>
          this.selectedDatasets.includes(Number(dataset.reportcreationid)) &&
          Number(dataset.objectGroup) === Number(objectGroupId)
        )
        .map(dataset => dataset.reportcreationid);

      if (datasetIds.length > 0) {
        // Join dataset IDs into a comma-separated string
        exportData[objectGroupId] = datasetIds.join(",");
      }
    }

    console.log('Export Data:', exportData);
    const jsonString = JSON.stringify(exportData);
    
    // Send the export data to the backend
    this.spinner.start();
    this.commonservice.exportDatasets(exportData)
      .subscribe(response => {
        const newBlob = new Blob([response], { type: 'application/zip' });
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(newBlob);
        link.href = url;
        link.download = 'Datasets.zip';
        link.click();
        this.spinner.stop();
        window.URL.revokeObjectURL(url);
      }, error => {
        console.error('Error sending export data:', error);
      });

    this.dialogRef.close();
  }
}


